/*how-it-works*/
/*inheritance-behavior*/
/*scalar-fields-are-inherited*/
/*array-fields-replace-by-default*/
/*extending-arrays-with-turboextends*/
/*extending-from-other-packages*/
/*inheritance-order*/
/*patterns-for-sharing-configuration*/
/*excluding-tasks-from-inheritance*/
/*excluding-a-task-entirely*/
/*creating-a-fresh-task-definition*/
/*exclusions-propagate-through-the-chain*/
/*examples*/
/*different-frameworks-in-one-workspace*/
/*specialized-tasks*/
/*comparison-to-package-specific-tasks*/
/*boundaries-tags-experimentalbadgeexperimentalexperimentalbadge*/
/*limitations*/
/*package-configurations-cannot-use-the-workspacetask-syntaxdocscrafting-your-repositoryrunning-tasks-as-task-entries*/
/*package-configurations-can-only-override-values-in-the-tasks-key*/
/*root-turbojson-cannot-use-the-extends-key*/
/*troubleshooting*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "软件包配置",
  "description": "学习如何使用包配置为 Monorepo 的包带来更大的任务灵活性。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "许多 monorepos 可以在根目录中声明一个 turbo.json，并在所有包中声明一个 任务描述。但是，有时，monorepo 可能包含需要以不同方式配置其任务的包。"
  }, {
    "heading": "",
    "content": "¥Many monorepos can declare a turbo.json in the root directory with a\ntask description that applies to all packages. But, sometimes, a monorepo can contain packages that need to configure their tasks differently."
  }, {
    "heading": "",
    "content": "为了实现这一点，Turborepo 允许你在任何包中使用 turbo.json 扩展根配置。这种灵活性使得更多样化的应用和软件包能够在工作区中共存，并允许软件包所有者维护专门的任务和配置，而不会影响 monorepo 的其他应用和软件包。"
  }, {
    "heading": "",
    "content": "¥To accommodate this, Turborepo enables you to extend the root configuration with a turbo.json in any package. This flexibility enables a more diverse set of apps and packages to co-exist in a Workspace, and allows package owners to maintain specialized tasks and configuration without affecting other apps and packages of the monorepo."
  }, {
    "heading": "工作原理-how-it-works",
    "content": "¥How it works"
  }, {
    "heading": "工作原理-how-it-works",
    "content": "要覆盖根 turbo.json 中定义的任何任务的配置，请在 monorepo 的任何软件包中添加一个带有顶层 extends 键的 turbo.json 文件："
  }, {
    "heading": "工作原理-how-it-works",
    "content": "¥To override the configuration for any task defined in the root turbo.json, add\na turbo.json file in any package of your monorepo with a top-level extends\nkey:"
  }, {
    "heading": "工作原理-how-it-works",
    "content": "extends 数组必须以 [\"//\"] 开头。// 是一个用于标识 monorepo 根目录的特殊名称。你还可以通过在 // 之后添加其他包（例如 [\"//\", \"shared-config\"]）来扩展它们。"
  }, {
    "heading": "工作原理-how-it-works",
    "content": "¥The extends array must start with [\"//\"]. // is a special name used to\nidentify the root directory of the monorepo. You can also extend from other\npackages by adding them after // (e.g., [\"//\", \"shared-config\"])."
  }, {
    "heading": "继承行为-inheritance-behavior",
    "content": "¥Inheritance behavior"
  }, {
    "heading": "继承行为-inheritance-behavior",
    "content": "当一个包配置继承自根 turbo.json 时，任务属性的继承方式取决于其类型。"
  }, {
    "heading": "继承行为-inheritance-behavior",
    "content": "¥When a Package Configuration extends the root turbo.json, task properties are inherited differently depending on their type."
  }, {
    "heading": "标量字段会被继承-scalar-fields-are-inherited",
    "content": "¥Scalar fields are inherited"
  }, {
    "heading": "标量字段会被继承-scalar-fields-are-inherited",
    "content": "标量字段（例如 outputLogs、cache、persistent 和 interactive）继承自根配置。只有当你想要覆盖它们时，才需要在包配置中指定它们。"
  }, {
    "heading": "标量字段会被继承-scalar-fields-are-inherited",
    "content": "¥Scalar fields like outputLogs, cache, persistent, and interactive are inherited from the root configuration. You only need to specify them in a Package Configuration if you want to override them."
  }, {
    "heading": "标量字段会被继承-scalar-fields-are-inherited",
    "content": "例如，如果你的根 turbo.json 为某个任务设置了 \"outputLogs\": \"hash-only\"，则所有包都会自动继承该设置。"
  }, {
    "heading": "标量字段会被继承-scalar-fields-are-inherited",
    "content": "¥For example, if your root turbo.json sets \"outputLogs\": \"hash-only\" for a task, all packages inherit that setting automatically."
  }, {
    "heading": "数组字段默认替换-array-fields-replace-by-default",
    "content": "¥Array fields replace by default"
  }, {
    "heading": "数组字段默认替换-array-fields-replace-by-default",
    "content": "默认情况下，数组字段（例如 outputs、env、inputs、dependsOn 和 passThroughEnv）会完全替换根配置的值。"
  }, {
    "heading": "数组字段默认替换-array-fields-replace-by-default",
    "content": "¥Array fields like outputs, env, inputs, dependsOn, and passThroughEnv completely replace the root configuration's values by default."
  }, {
    "heading": "使用-turbo_extends-扩展数组-extending-arrays-with-turboextends",
    "content": "¥Extending arrays with $TURBO_EXTENDS$"
  }, {
    "heading": "使用-turbo_extends-扩展数组-extending-arrays-with-turboextends",
    "content": "要向继承的数组值添加内容而不是替换它们，请使用 $TURBO_EXTENDS$ 微语法："
  }, {
    "heading": "使用-turbo_extends-扩展数组-extending-arrays-with-turboextends",
    "content": "¥To add to inherited array values instead of replacing them, use the $TURBO_EXTENDS$ microsyntax:"
  }, {
    "heading": "使用-turbo_extends-扩展数组-extending-arrays-with-turboextends",
    "content": "$TURBO_EXTENDS$ 标记必须是数组中的第一个元素。它适用于 outputs、env、inputs、dependsOn、passThroughEnv 和 with。"
  }, {
    "heading": "使用-turbo_extends-扩展数组-extending-arrays-with-turboextends",
    "content": "¥The $TURBO_EXTENDS$ marker must be the first element in the array. It works with outputs, env, inputs, dependsOn, passThroughEnv, and with."
  }, {
    "heading": "从其他包扩展-extending-from-other-packages",
    "content": "¥Extending from other packages"
  }, {
    "heading": "从其他包扩展-extending-from-other-packages",
    "content": "包配置可以继承自其他包的 turbo.json 文件，而不仅仅是根包。这允许跨包组合共享任务配置。"
  }, {
    "heading": "从其他包扩展-extending-from-other-packages",
    "content": "¥Package Configurations can extend from other packages' turbo.json files, not just the root. This enables composing shared task configurations across packages."
  }, {
    "heading": "从其他包扩展-extending-from-other-packages",
    "content": "通过在 extends 数组中使用其 package.json 中的 name 来继承任何包。例如，如果你有一个位于 ./apps/web 的 Next.js 应用，其 package.json 中包含 \"name\": \"web\"："
  }, {
    "heading": "从其他包扩展-extending-from-other-packages",
    "content": "¥Extend from any package by using its name from package.json in your extends array. For example, if you have a Next.js app at ./apps/web with \"name\": \"web\" in its package.json:"
  }, {
    "heading": "从其他包扩展-extending-from-other-packages",
    "content": "其他 Next.js 应用可以继承此配置并共享相同的配置："
  }, {
    "heading": "从其他包扩展-extending-from-other-packages",
    "content": "¥Another Next.js app can extend from it to share the same configuration:"
  }, {
    "heading": "从其他包扩展-extending-from-other-packages",
    "content": "当继承自多个配置时，根 (\"//\") 必须始终在 extends 数组中列在第一位。"
  }, {
    "heading": "从其他包扩展-extending-from-other-packages",
    "content": "¥When extending from multiple configurations, the root (\"//\") must always be\nlisted first in the extends array."
  }, {
    "heading": "继承顺序-inheritance-order",
    "content": "¥Inheritance order"
  }, {
    "heading": "继承顺序-inheritance-order",
    "content": "当继承自多个配置时，任务定义会按照它们在 extends 数组中出现的顺序合并："
  }, {
    "heading": "继承顺序-inheritance-order",
    "content": "¥When extending from multiple configurations, task definitions are merged in the order they appear in the extends array:"
  }, {
    "heading": "继承顺序-inheritance-order",
    "content": "根包的 turbo.json (\"//\") 首先应用。"
  }, {
    "heading": "继承顺序-inheritance-order",
    "content": "¥Root turbo.json (\"//\") is applied first"
  }, {
    "heading": "继承顺序-inheritance-order",
    "content": "每个附加包配置按顺序应用。"
  }, {
    "heading": "继承顺序-inheritance-order",
    "content": "¥Each additional package configuration is applied in order"
  }, {
    "heading": "继承顺序-inheritance-order",
    "content": "当前包的配置最后应用。"
  }, {
    "heading": "继承顺序-inheritance-order",
    "content": "¥The current package's configuration is applied last"
  }, {
    "heading": "继承顺序-inheritance-order",
    "content": "对于标量字段，后续配置会覆盖早期配置。对于数组字段，请参阅“追加而不是替换 使用 $TURBO_EXTENDS$ 扩展数组”。"
  }, {
    "heading": "继承顺序-inheritance-order",
    "content": "¥Later configurations override earlier ones for scalar fields. For array fields, see Extending arrays with $TURBO_EXTENDS$ to append instead of replace."
  }, {
    "heading": "共享配置的模式-patterns-for-sharing-configuration",
    "content": "¥Patterns for sharing configuration"
  }, {
    "heading": "共享配置的模式-patterns-for-sharing-configuration",
    "content": "从现有包继承：如果你已经有一个包含要共享的配置的包，则其他包可以直接继承该配置。当一个包作为类似包的 \"canonical\" 示例时（例如，其他 Next.js 应用可以继承的主 Next.js 应用），此方法非常有效。"
  }, {
    "heading": "共享配置的模式-patterns-for-sharing-configuration",
    "content": "¥Extend from an existing package: If you already have a package with the configuration you want to share, other packages can extend from it directly. This works well when one package serves as the \"canonical\" example for similar packages (e.g., your main Next.js app that other Next.js apps can extend from)."
  }, {
    "heading": "共享配置的模式-patterns-for-sharing-configuration",
    "content": "创建专用配置包：对于较大的单体仓库，你可能需要创建专门用于共享配置的包。这使配置与应用代码分离，并明确表明其他包依赖于这些设置。这些包通常只包含 package.json 和 turbo.json。"
  }, {
    "heading": "共享配置的模式-patterns-for-sharing-configuration",
    "content": "¥Create a dedicated configuration package: For larger monorepos, you may want to create packages specifically for sharing configuration. This keeps configuration separate from application code and makes it clear that other packages depend on these settings. These packages typically only contain a package.json and turbo.json."
  }, {
    "heading": "从继承中排除任务-excluding-tasks-from-inheritance",
    "content": "¥Excluding tasks from inheritance"
  }, {
    "heading": "从继承中排除任务-excluding-tasks-from-inheritance",
    "content": "当继承自根或其他包时，你的包默认会继承它们的所有任务定义。你可以使用任务级别的 extends 字段来选择退出特定任务。"
  }, {
    "heading": "从继承中排除任务-excluding-tasks-from-inheritance",
    "content": "¥When extending from the root or other packages, your package inherits all their task definitions by default. You can use the task-level extends field to opt out of specific tasks."
  }, {
    "heading": "完全排除任务-excluding-a-task-entirely",
    "content": "¥Excluding a task entirely"
  }, {
    "heading": "完全排除任务-excluding-a-task-entirely",
    "content": "要从包中完全排除继承的任务，请设置 extends: false 而不进行任何其他配置："
  }, {
    "heading": "完全排除任务-excluding-a-task-entirely",
    "content": "¥To completely exclude an inherited task from your package, set extends: false with no other configuration:"
  }, {
    "heading": "完全排除任务-excluding-a-task-entirely",
    "content": "运行 turbo run lint 时，对于 lint 任务，将完全跳过 ui 包。"
  }, {
    "heading": "完全排除任务-excluding-a-task-entirely",
    "content": "¥When you run turbo run lint, the ui package will be skipped entirely for the lint task."
  }, {
    "heading": "创建新的任务定义-creating-a-fresh-task-definition",
    "content": "¥Creating a fresh task definition"
  }, {
    "heading": "创建新的任务定义-creating-a-fresh-task-definition",
    "content": "要创建不从 extends 链继承任何配置的新任务定义，请将 extends: false 与其他任务配置一起使用："
  }, {
    "heading": "创建新的任务定义-creating-a-fresh-task-definition",
    "content": "¥To create a new task definition that doesn't inherit any configuration from the extends chain, use extends: false along with other task configuration:"
  }, {
    "heading": "创建新的任务定义-creating-a-fresh-task-definition",
    "content": "当你需要完全不同的任务配置，且这些配置不应与继承的值合并时，此功能非常有用。"
  }, {
    "heading": "创建新的任务定义-creating-a-fresh-task-definition",
    "content": "¥This is useful when you need completely different task configuration that shouldn't merge with inherited values."
  }, {
    "heading": "排除项会沿着链传播-exclusions-propagate-through-the-chain",
    "content": "¥Exclusions propagate through the chain"
  }, {
    "heading": "排除项会沿着链传播-exclusions-propagate-through-the-chain",
    "content": "当一个包排除某个任务时，该排除会传播到继承自它的包："
  }, {
    "heading": "排除项会沿着链传播-exclusions-propagate-through-the-chain",
    "content": "¥When a package excludes a task, that exclusion propagates to packages that extend from it:"
  }, {
    "heading": "排除项会沿着链传播-exclusions-propagate-through-the-chain",
    "content": "任务级别的 extends 仅在包配置中可用。在根目录 turbo.json 中的任务上使用 extends 将导致验证错误。"
  }, {
    "heading": "排除项会沿着链传播-exclusions-propagate-through-the-chain",
    "content": "¥Task-level extends is only available in Package Configurations. Using\nextends on a task in the root turbo.json will result in a validation\nerror."
  }, {
    "heading": "示例-examples",
    "content": "¥Examples"
  }, {
    "heading": "在一个应用中使用不同的框架工作区-different-frameworks-in-one-workspace",
    "content": "¥Different frameworks in one Workspace"
  }, {
    "heading": "在一个应用中使用不同的框架工作区-different-frameworks-in-one-workspace",
    "content": "假设你的 monorepo 包含多个 Next.js 应用和一个 SvelteKit 应用。这两个框架都在各自的 package.json 中使用 build 脚本创建构建输出。你可以像这样配置 Turborepo，使其在根目录下使用单个 turbo.json 任务来运行这些任务："
  }, {
    "heading": "在一个应用中使用不同的框架工作区-different-frameworks-in-one-workspace",
    "content": "¥Let's say your monorepo has multiple Next.js apps, and one SvelteKit\napp. Both frameworks create their build output with a build script in their\nrespective package.json. You could configure Turborepo to run these tasks\nwith a single turbo.json at the root like this:"
  }, {
    "heading": "在一个应用中使用不同的框架工作区-different-frameworks-in-one-workspace",
    "content": "请注意，即使 Next.js 应用不会生成 .svelte-kit 目录，.next/** 和 .svelte-kit/** 都需要指定为 outputs，反之亦然。"
  }, {
    "heading": "在一个应用中使用不同的框架工作区-different-frameworks-in-one-workspace",
    "content": "¥Notice that both .next/** and .svelte-kit/** need to be specified as\noutputs, even though Next.js apps do not generate a .svelte-kit directory, and\nvice versa."
  }, {
    "heading": "在一个应用中使用不同的框架工作区-different-frameworks-in-one-workspace",
    "content": "使用包配置，你可以在 apps/my-svelte-kit-app/turbo.json 中的 SvelteKit 包中添加自定义配置："
  }, {
    "heading": "在一个应用中使用不同的框架工作区-different-frameworks-in-one-workspace",
    "content": "¥With Package Configurations, you can instead add custom\nconfiguration in the SvelteKit package in apps/my-svelte-kit-app/turbo.json:"
  }, {
    "heading": "在一个应用中使用不同的框架工作区-different-frameworks-in-one-workspace",
    "content": "并从根配置中移除 SvelteKit 特定的 outputs："
  }, {
    "heading": "在一个应用中使用不同的框架工作区-different-frameworks-in-one-workspace",
    "content": "¥and remove the SvelteKit-specific outputs from the root configuration:"
  }, {
    "heading": "在一个应用中使用不同的框架工作区-different-frameworks-in-one-workspace",
    "content": "这不仅使每个配置更易于阅读，还使配置更接近其使用位置。"
  }, {
    "heading": "在一个应用中使用不同的框架工作区-different-frameworks-in-one-workspace",
    "content": "¥This not only makes each configuration easier to read, it puts the configuration\ncloser to where it is used."
  }, {
    "heading": "专门的任务-specialized-tasks",
    "content": "¥Specialized tasks"
  }, {
    "heading": "专门的任务-specialized-tasks",
    "content": "再举一个例子，假设一个软件包 dependsOn 中的 build 任务调用了一个 compile 任务。你可以将其声明为 dependsOn: [\"compile\"]。这意味着你的根 turbo.json 必须有一个空的 compile 任务条目："
  }, {
    "heading": "专门的任务-specialized-tasks",
    "content": "¥In another example, say that the build task in one package dependsOn a\ncompile task. You could universally declare it as dependsOn: [\"compile\"].\nThis means that your root turbo.json has to have an empty compile task\nentry:"
  }, {
    "heading": "专门的任务-specialized-tasks",
    "content": "使用包配置，你可以将该 compile 任务移动到 apps/my-custom-app/turbo.json，"
  }, {
    "heading": "专门的任务-specialized-tasks",
    "content": "¥With Package Configurations, you can move that compile task into the\napps/my-custom-app/turbo.json,"
  }, {
    "heading": "专门的任务-specialized-tasks",
    "content": "并将其从根目录中移除："
  }, {
    "heading": "专门的任务-specialized-tasks",
    "content": "¥and remove it from the root:"
  }, {
    "heading": "专门的任务-specialized-tasks",
    "content": "现在，my-app 的所有者可以完全拥有其 build 任务的所有权，但可以继续继承根目录中定义的任何其他任务。"
  }, {
    "heading": "专门的任务-specialized-tasks",
    "content": "¥Now, the owners of my-app, can have full ownership over their build task,\nbut continue to inherit any other tasks defined at the root."
  }, {
    "heading": "与特定于软件包的任务的比较-comparison-to-package-specific-tasks",
    "content": "¥Comparison to package-specific tasks"
  }, {
    "heading": "与特定于软件包的任务的比较-comparison-to-package-specific-tasks",
    "content": "根包 turbo.json 中的 package#task 语法 会完全覆盖所有任务配置 - 不会继承任何配置。"
  }, {
    "heading": "与特定于软件包的任务的比较-comparison-to-package-specific-tasks",
    "content": "¥The package#task syntax in the root turbo.json completely overwrites all task configuration—nothing is inherited."
  }, {
    "heading": "与特定于软件包的任务的比较-comparison-to-package-specific-tasks",
    "content": "对于包配置，标量字段会被继承，只有你指定的字段会被覆盖。这意味着当你只需要更改一两个属性时，可以减少重复代码。"
  }, {
    "heading": "与特定于软件包的任务的比较-comparison-to-package-specific-tasks",
    "content": "¥With Package Configurations, scalar fields are inherited and only the fields you specify are overridden. This means less duplication when you only need to change one or two properties."
  }, {
    "heading": "与特定于软件包的任务的比较-comparison-to-package-specific-tasks",
    "content": "虽然没有计划移除特定于包的任务配置，但我们预计在大多数情况下可以使用包配置。"
  }, {
    "heading": "与特定于软件包的任务的比较-comparison-to-package-specific-tasks",
    "content": "¥Although there are no plans to remove package-specific task configurations, we\nexpect that Package Configurations can be used for most use cases instead."
  }, {
    "heading": "experimental-边界标签-boundaries-tags-experimentalbadgeexperimentalexperimentalbadge",
    "content": "¥Boundaries Tags Experimental"
  }, {
    "heading": "experimental-边界标签-boundaries-tags-experimentalbadgeexperimentalexperimentalbadge",
    "content": "软件包配置也用于声明边界标签。为此，请在你的 turbo.json 中添加一个 tags 字段："
  }, {
    "heading": "experimental-边界标签-boundaries-tags-experimentalbadgeexperimentalexperimentalbadge",
    "content": "¥Package Configurations are also used to declare Tags for Boundaries. To do so, add a tags field to your turbo.json:"
  }, {
    "heading": "experimental-边界标签-boundaries-tags-experimentalbadgeexperimentalexperimentalbadge",
    "content": "从这里，你可以定义标签可以包含哪些依赖或被依赖的规则。查看 边界文档 了解更多详细信息。"
  }, {
    "heading": "experimental-边界标签-boundaries-tags-experimentalbadgeexperimentalexperimentalbadge",
    "content": "¥From there, you can define rules for which dependencies or dependents a tag can have. Check out the Boundaries documentation for more details."
  }, {
    "heading": "限制-limitations",
    "content": "¥Limitations"
  }, {
    "heading": "限制-limitations",
    "content": "虽然总体思路与根 turbo.json 相同，但软件包配置附带一组防护措施，可以防止软件包造成潜在的混乱情况。"
  }, {
    "heading": "限制-limitations",
    "content": "¥Although the general idea is the same as the root turbo.json, Package\nConfigurations come with a set of guardrails that can prevent packages from creating\npotentially confusing situations."
  }, {
    "heading": "软件包配置不能使用-workspacetask-语法-作为任务条目-package-configurations-cannot-use-the-workspacetask-syntaxdocscrafting-your-repositoryrunning-tasks-as-task-entries",
    "content": "¥Package Configurations cannot use the workspace#task syntax as task entries"
  }, {
    "heading": "软件包配置不能使用-workspacetask-语法-作为任务条目-package-configurations-cannot-use-the-workspacetask-syntaxdocscrafting-your-repositoryrunning-tasks-as-task-entries",
    "content": "package 是根据配置的位置推断出来的，并且无法更改其他包的配置。例如，在 my-nextjs-app 的包配置中："
  }, {
    "heading": "软件包配置不能使用-workspacetask-语法-作为任务条目-package-configurations-cannot-use-the-workspacetask-syntaxdocscrafting-your-repositoryrunning-tasks-as-task-entries",
    "content": "¥The package is inferred based on the location of the configuration, and it is\nnot possible to change configuration for another package. For example, in a\nPackage Configuration for my-nextjs-app:"
  }, {
    "heading": "软件包配置不能使用-workspacetask-语法-作为任务条目-package-configurations-cannot-use-the-workspacetask-syntaxdocscrafting-your-repositoryrunning-tasks-as-task-entries",
    "content": "请注意，build 任务仍然可以依赖于特定于包的任务："
  }, {
    "heading": "软件包配置不能使用-workspacetask-语法-作为任务条目-package-configurations-cannot-use-the-workspacetask-syntaxdocscrafting-your-repositoryrunning-tasks-as-task-entries",
    "content": "¥Note that the build task can still depend on a package-specific task:"
  }, {
    "heading": "软件包配置只能覆盖-tasks-键中的值-package-configurations-can-only-override-values-in-the-tasks-key",
    "content": "¥Package Configurations can only override values in the tasks key"
  }, {
    "heading": "软件包配置只能覆盖-tasks-键中的值-package-configurations-can-only-override-values-in-the-tasks-key",
    "content": "无法在包配置中像 globalEnv 或 globalDependencies 那样覆盖 全局配置。需要在包配置中更改的配置并非真正全局的，应该进行不同的配置。"
  }, {
    "heading": "软件包配置只能覆盖-tasks-键中的值-package-configurations-can-only-override-values-in-the-tasks-key",
    "content": "¥It is not possible to override global configuration like globalEnv or globalDependencies in a Package Configuration. Configuration that would need to be altered in a Package Configuration is not truly global and should be configured differently."
  }, {
    "heading": "root-turbojson-无法使用-extends-键-root-turbojson-cannot-use-the-extends-key",
    "content": "¥Root turbo.json cannot use the extends key"
  }, {
    "heading": "root-turbojson-无法使用-extends-键-root-turbojson-cannot-use-the-extends-key",
    "content": "为避免在包上创建循环依赖，根 turbo.json 不能从任何包扩展。extends 键将被忽略。"
  }, {
    "heading": "root-turbojson-无法使用-extends-键-root-turbojson-cannot-use-the-extends-key",
    "content": "¥To avoid creating circular dependencies on packages, the root turbo.json\ncannot extend from anything. The extends key will be ignored."
  }, {
    "heading": "故障排除-troubleshooting",
    "content": "¥Troubleshooting"
  }, {
    "heading": "故障排除-troubleshooting",
    "content": "在大型单体仓库中，有时可能很难理解 Turborepo 如何解释你的配置。为了提供帮助，我们在 试运行 输出中添加了 resolvedTaskDefinition。例如，如果你运行 turbo run build --dry-run，输出将包含在运行 build 任务之前考虑的所有 turbo.json 配置的组合。"
  }, {
    "heading": "故障排除-troubleshooting",
    "content": "¥In large monorepos, it can sometimes be difficult to understand how Turborepo is\ninterpreting your configuration. To help, we've added a resolvedTaskDefinition\nto the Dry Run output. If you run turbo run build --dry-run, for example, the\noutput will include the combination of all turbo.json configurations that were\nconsidered before running the build task."
  }],
  "headings": [{
    "id": "工作原理-how-it-works",
    "content": "工作原理 /*how-it-works*/"
  }, {
    "id": "继承行为-inheritance-behavior",
    "content": "继承行为 /*inheritance-behavior*/"
  }, {
    "id": "标量字段会被继承-scalar-fields-are-inherited",
    "content": "标量字段会被继承 /*scalar-fields-are-inherited*/"
  }, {
    "id": "数组字段默认替换-array-fields-replace-by-default",
    "content": "数组字段默认替换 /*array-fields-replace-by-default*/"
  }, {
    "id": "使用-turbo_extends-扩展数组-extending-arrays-with-turboextends",
    "content": "使用 $TURBO_EXTENDS$ 扩展数组 /*extending-arrays-with-turboextends*/"
  }, {
    "id": "从其他包扩展-extending-from-other-packages",
    "content": "从其他包扩展 /*extending-from-other-packages*/"
  }, {
    "id": "继承顺序-inheritance-order",
    "content": "继承顺序 /*inheritance-order*/"
  }, {
    "id": "共享配置的模式-patterns-for-sharing-configuration",
    "content": "共享配置的模式 /*patterns-for-sharing-configuration*/"
  }, {
    "id": "从继承中排除任务-excluding-tasks-from-inheritance",
    "content": "从继承中排除任务 /*excluding-tasks-from-inheritance*/"
  }, {
    "id": "完全排除任务-excluding-a-task-entirely",
    "content": "完全排除任务 /*excluding-a-task-entirely*/"
  }, {
    "id": "创建新的任务定义-creating-a-fresh-task-definition",
    "content": "创建新的任务定义 /*creating-a-fresh-task-definition*/"
  }, {
    "id": "排除项会沿着链传播-exclusions-propagate-through-the-chain",
    "content": "排除项会沿着链传播 /*exclusions-propagate-through-the-chain*/"
  }, {
    "id": "示例-examples",
    "content": "示例 /*examples*/"
  }, {
    "id": "在一个应用中使用不同的框架工作区-different-frameworks-in-one-workspace",
    "content": "在一个应用中使用不同的框架工作区 /*different-frameworks-in-one-workspace*/"
  }, {
    "id": "专门的任务-specialized-tasks",
    "content": "专门的任务 /*specialized-tasks*/"
  }, {
    "id": "与特定于软件包的任务的比较-comparison-to-package-specific-tasks",
    "content": "与特定于软件包的任务的比较 /*comparison-to-package-specific-tasks*/"
  }, {
    "id": "experimental-边界标签-boundaries-tags-experimentalbadgeexperimentalexperimentalbadge",
    "content": "Experimental 边界标签 /*boundaries-tags-experimentalbadgeexperimentalexperimentalbadge*/"
  }, {
    "id": "限制-limitations",
    "content": "限制 /*limitations*/"
  }, {
    "id": "软件包配置不能使用-workspacetask-语法-作为任务条目-package-configurations-cannot-use-the-workspacetask-syntaxdocscrafting-your-repositoryrunning-tasks-as-task-entries",
    "content": "软件包配置不能使用 workspace#task 语法 作为任务条目 /*package-configurations-cannot-use-the-workspacetask-syntaxdocscrafting-your-repositoryrunning-tasks-as-task-entries*/"
  }, {
    "id": "软件包配置只能覆盖-tasks-键中的值-package-configurations-can-only-override-values-in-the-tasks-key",
    "content": "软件包配置只能覆盖 tasks 键中的值 /*package-configurations-can-only-override-values-in-the-tasks-key*/"
  }, {
    "id": "root-turbojson-无法使用-extends-键-root-turbojson-cannot-use-the-extends-key",
    "content": "Root turbo.json 无法使用 extends 键 /*root-turbojson-cannot-use-the-extends-key*/"
  }, {
    "id": "故障排除-troubleshooting",
    "content": "故障排除 /*troubleshooting*/"
  }]
};
import {Callout} from '#components/callout';
import {ExperimentalBadge} from '#components/experimental-badge';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
export const toc = [{
  depth: 2,
  url: "#工作原理-how-it-works",
  title: _jsx(_Fragment, {
    children: "工作原理 "
  })
}, {
  depth: 2,
  url: "#继承行为-inheritance-behavior",
  title: _jsx(_Fragment, {
    children: "继承行为 "
  })
}, {
  depth: 3,
  url: "#标量字段会被继承-scalar-fields-are-inherited",
  title: _jsx(_Fragment, {
    children: "标量字段会被继承 "
  })
}, {
  depth: 3,
  url: "#数组字段默认替换-array-fields-replace-by-default",
  title: _jsx(_Fragment, {
    children: "数组字段默认替换 "
  })
}, {
  depth: 3,
  url: "#使用-turbo_extends-扩展数组-extending-arrays-with-turboextends",
  title: _jsxs(_Fragment, {
    children: ["使用 ", _jsx("code", {
      children: "$TURBO_EXTENDS$"
    }), " 扩展数组 "]
  })
}, {
  depth: 3,
  url: "#从其他包扩展-extending-from-other-packages",
  title: _jsx(_Fragment, {
    children: "从其他包扩展 "
  })
}, {
  depth: 4,
  url: "#继承顺序-inheritance-order",
  title: _jsx(_Fragment, {
    children: "继承顺序 "
  })
}, {
  depth: 4,
  url: "#共享配置的模式-patterns-for-sharing-configuration",
  title: _jsx(_Fragment, {
    children: "共享配置的模式 "
  })
}, {
  depth: 3,
  url: "#从继承中排除任务-excluding-tasks-from-inheritance",
  title: _jsx(_Fragment, {
    children: "从继承中排除任务 "
  })
}, {
  depth: 4,
  url: "#完全排除任务-excluding-a-task-entirely",
  title: _jsx(_Fragment, {
    children: "完全排除任务 "
  })
}, {
  depth: 4,
  url: "#创建新的任务定义-creating-a-fresh-task-definition",
  title: _jsx(_Fragment, {
    children: "创建新的任务定义 "
  })
}, {
  depth: 4,
  url: "#排除项会沿着链传播-exclusions-propagate-through-the-chain",
  title: _jsx(_Fragment, {
    children: "排除项会沿着链传播 "
  })
}, {
  depth: 2,
  url: "#示例-examples",
  title: _jsx(_Fragment, {
    children: "示例 "
  })
}, {
  depth: 3,
  url: "#在一个应用中使用不同的框架工作区-different-frameworks-in-one-workspace",
  title: _jsx(_Fragment, {
    children: "在一个应用中使用不同的框架工作区 "
  })
}, {
  depth: 3,
  url: "#专门的任务-specialized-tasks",
  title: _jsx(_Fragment, {
    children: "专门的任务 "
  })
}, {
  depth: 2,
  url: "#与特定于软件包的任务的比较-comparison-to-package-specific-tasks",
  title: _jsx(_Fragment, {
    children: "与特定于软件包的任务的比较 "
  })
}, {
  depth: 2,
  url: "#experimental-边界标签-boundaries-tags-experimentalbadgeexperimentalexperimentalbadge",
  title: _jsxs(_Fragment, {
    children: [_jsx(ExperimentalBadge, {
      children: "Experimental"
    }), " 边界标签 "]
  })
}, {
  depth: 2,
  url: "#限制-limitations",
  title: _jsx(_Fragment, {
    children: "限制 "
  })
}, {
  depth: 3,
  url: "#软件包配置不能使用-workspacetask-语法-作为任务条目-package-configurations-cannot-use-the-workspacetask-syntaxdocscrafting-your-repositoryrunning-tasks-as-task-entries",
  title: _jsxs(_Fragment, {
    children: ["软件包配置不能使用 ", _jsxs("a", {
      href: "/docs/crafting-your-repository/running-tasks",
      children: [_jsx("code", {
        children: "workspace#task"
      }), " 语法"]
    }), " 作为任务条目 "]
  })
}, {
  depth: 3,
  url: "#软件包配置只能覆盖-tasks-键中的值-package-configurations-can-only-override-values-in-the-tasks-key",
  title: _jsxs(_Fragment, {
    children: ["软件包配置只能覆盖 ", _jsx("code", {
      children: "tasks"
    }), " 键中的值 "]
  })
}, {
  depth: 3,
  url: "#root-turbojson-无法使用-extends-键-root-turbojson-cannot-use-the-extends-key",
  title: _jsxs(_Fragment, {
    children: ["Root turbo.json 无法使用 ", _jsx("code", {
      children: "extends"
    }), " 键 "]
  })
}, {
  depth: 2,
  url: "#故障排除-troubleshooting",
  title: _jsx(_Fragment, {
    children: "故障排除 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["许多 monorepos 可以在根目录中声明一个 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "，并在所有包中声明一个 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#tasks",
        children: "任务描述"
      }), "。但是，有时，monorepo 可能包含需要以不同方式配置其任务的包。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Many monorepos can declare a ", _jsx(_components.code, {
        children: "turbo.json"
      }), " in the root directory with a\n", _jsx(_components.a, {
        href: "/docs/reference/configuration#tasks",
        children: "task description"
      }), " that applies to all packages. But, sometimes, a monorepo can contain packages that need to configure their tasks differently."]
    }), "\n", _jsxs(_components.p, {
      children: ["为了实现这一点，Turborepo 允许你在任何包中使用 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 扩展根配置。这种灵活性使得更多样化的应用和软件包能够在工作区中共存，并允许软件包所有者维护专门的任务和配置，而不会影响 monorepo 的其他应用和软件包。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To accommodate this, Turborepo enables you to extend the root configuration with a ", _jsx(_components.code, {
        children: "turbo.json"
      }), " in any package. This flexibility enables a more diverse set of apps and packages to co-exist in a Workspace, and allows package owners to maintain specialized tasks and configuration without affecting other apps and packages of the monorepo."]
    }), "\n", _jsx(_components.h2, {
      id: "工作原理-how-it-works",
      children: "工作原理 "
    }), "\n", _jsx(_components.p, {
      children: "¥How it works"
    }), "\n", _jsxs(_components.p, {
      children: ["要覆盖根 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中定义的任何任务的配置，请在 monorepo 的任何软件包中添加一个带有顶层 ", _jsx(_components.code, {
        children: "extends"
      }), " 键的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 文件："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To override the configuration for any task defined in the root ", _jsx(_components.code, {
        children: "turbo.json"
      }), ", add\na ", _jsx(_components.code, {
        children: "turbo.json"
      }), " file in any package of your monorepo with a top-level ", _jsx(_components.code, {
        children: "extends"
      }), "\nkey:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/my-app/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // Custom configuration for the build task in this package"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"special-task\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {} "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// New task specific to this package"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "extends"
        }), " 数组必须以 ", _jsx(_components.code, {
          children: "[\"//\"]"
        }), " 开头。", _jsx(_components.code, {
          children: "//"
        }), " 是一个用于标识 monorepo 根目录的特殊名称。你还可以通过在 ", _jsx(_components.code, {
          children: "//"
        }), " 之后添加其他包（例如 ", _jsx(_components.code, {
          children: "[\"//\", \"shared-config\"]"
        }), "）来扩展它们。"]
      }), _jsxs(_components.p, {
        children: ["¥The ", _jsx(_components.code, {
          children: "extends"
        }), " array must start with ", _jsx(_components.code, {
          children: "[\"//\"]"
        }), ". ", _jsx(_components.code, {
          children: "//"
        }), " is a special name used to\nidentify the root directory of the monorepo. You can also extend from other\npackages by adding them after ", _jsx(_components.code, {
          children: "//"
        }), " (e.g., ", _jsx(_components.code, {
          children: "[\"//\", \"shared-config\"]"
        }), ")."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "继承行为-inheritance-behavior",
      children: "继承行为 "
    }), "\n", _jsx(_components.p, {
      children: "¥Inheritance behavior"
    }), "\n", _jsxs(_components.p, {
      children: ["当一个包配置继承自根 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 时，任务属性的继承方式取决于其类型。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When a Package Configuration extends the root ", _jsx(_components.code, {
        children: "turbo.json"
      }), ", task properties are inherited differently depending on their type."]
    }), "\n", _jsx(_components.h3, {
      id: "标量字段会被继承-scalar-fields-are-inherited",
      children: "标量字段会被继承 "
    }), "\n", _jsx(_components.p, {
      children: "¥Scalar fields are inherited"
    }), "\n", _jsxs(_components.p, {
      children: ["标量字段（例如 ", _jsx(_components.code, {
        children: "outputLogs"
      }), "、", _jsx(_components.code, {
        children: "cache"
      }), "、", _jsx(_components.code, {
        children: "persistent"
      }), " 和 ", _jsx(_components.code, {
        children: "interactive"
      }), "）继承自根配置。只有当你想要覆盖它们时，才需要在包配置中指定它们。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Scalar fields like ", _jsx(_components.code, {
        children: "outputLogs"
      }), ", ", _jsx(_components.code, {
        children: "cache"
      }), ", ", _jsx(_components.code, {
        children: "persistent"
      }), ", and ", _jsx(_components.code, {
        children: "interactive"
      }), " are ", _jsx(_components.strong, {
        children: "inherited"
      }), " from the root configuration. You only need to specify them in a Package Configuration if you want to override them."]
    }), "\n", _jsxs(_components.p, {
      children: ["例如，如果你的根 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 为某个任务设置了 ", _jsx(_components.code, {
        children: "\"outputLogs\": \"hash-only\""
      }), "，则所有包都会自动继承该设置。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For example, if your root ", _jsx(_components.code, {
        children: "turbo.json"
      }), " sets ", _jsx(_components.code, {
        children: "\"outputLogs\": \"hash-only\""
      }), " for a task, all packages inherit that setting automatically."]
    }), "\n", _jsx(_components.h3, {
      id: "数组字段默认替换-array-fields-replace-by-default",
      children: "数组字段默认替换 "
    }), "\n", _jsx(_components.p, {
      children: "¥Array fields replace by default"
    }), "\n", _jsxs(_components.p, {
      children: ["默认情况下，数组字段（例如 ", _jsx(_components.code, {
        children: "outputs"
      }), "、", _jsx(_components.code, {
        children: "env"
      }), "、", _jsx(_components.code, {
        children: "inputs"
      }), "、", _jsx(_components.code, {
        children: "dependsOn"
      }), " 和 ", _jsx(_components.code, {
        children: "passThroughEnv"
      }), "）会完全替换根配置的值。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Array fields like ", _jsx(_components.code, {
        children: "outputs"
      }), ", ", _jsx(_components.code, {
        children: "env"
      }), ", ", _jsx(_components.code, {
        children: "inputs"
      }), ", ", _jsx(_components.code, {
        children: "dependsOn"
      }), ", and ", _jsx(_components.code, {
        children: "passThroughEnv"
      }), " ", _jsx(_components.strong, {
        children: "completely replace"
      }), " the root configuration's values by default."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"dist/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"NODE_ENV\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/my-app/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // This REPLACES the root outputs - \"dist/**\" is NOT included"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".next/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "使用-turbo_extends-扩展数组-extending-arrays-with-turboextends",
      children: ["使用 ", _jsx(_components.code, {
        children: "$TURBO_EXTENDS$"
      }), " 扩展数组 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Extending arrays with ", _jsx(_components.code, {
        children: "$TURBO_EXTENDS$"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["要向继承的数组值添加内容而不是替换它们，请使用 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#turbo_extends",
        children: [_jsx(_components.code, {
          children: "$TURBO_EXTENDS$"
        }), " 微语法"]
      }), "："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To ", _jsx(_components.strong, {
        children: "add"
      }), " to inherited array values instead of replacing them, use the ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#turbo_extends",
        children: [_jsx(_components.code, {
          children: "$TURBO_EXTENDS$"
        }), " microsyntax"]
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/my-app/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // Inherits \"dist/**\" from root AND adds \".next/**\""
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_EXTENDS$\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \".next/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "$TURBO_EXTENDS$"
      }), " 标记必须是数组中的第一个元素。它适用于 ", _jsx(_components.code, {
        children: "outputs"
      }), "、", _jsx(_components.code, {
        children: "env"
      }), "、", _jsx(_components.code, {
        children: "inputs"
      }), "、", _jsx(_components.code, {
        children: "dependsOn"
      }), "、", _jsx(_components.code, {
        children: "passThroughEnv"
      }), " 和 ", _jsx(_components.code, {
        children: "with"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "$TURBO_EXTENDS$"
      }), " marker must be the first element in the array. It works with ", _jsx(_components.code, {
        children: "outputs"
      }), ", ", _jsx(_components.code, {
        children: "env"
      }), ", ", _jsx(_components.code, {
        children: "inputs"
      }), ", ", _jsx(_components.code, {
        children: "dependsOn"
      }), ", ", _jsx(_components.code, {
        children: "passThroughEnv"
      }), ", and ", _jsx(_components.code, {
        children: "with"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "从其他包扩展-extending-from-other-packages",
      children: "从其他包扩展 "
    }), "\n", _jsx(_components.p, {
      children: "¥Extending from other packages"
    }), "\n", _jsxs(_components.p, {
      children: ["包配置可以继承自其他包的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 文件，而不仅仅是根包。这允许跨包组合共享任务配置。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Package Configurations can extend from other packages' ", _jsx(_components.code, {
        children: "turbo.json"
      }), " files, not just the root. This enables composing shared task configurations across packages."]
    }), "\n", _jsxs(_components.p, {
      children: ["通过在 ", _jsx(_components.code, {
        children: "extends"
      }), " 数组中使用其 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中的 ", _jsx(_components.code, {
        children: "name"
      }), " 来继承任何包。例如，如果你有一个位于 ", _jsx(_components.code, {
        children: "./apps/web"
      }), " 的 Next.js 应用，其 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中包含 ", _jsx(_components.code, {
        children: "\"name\": \"web\""
      }), "："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Extend from any package by using its ", _jsx(_components.code, {
        children: "name"
      }), " from ", _jsx(_components.code, {
        children: "package.json"
      }), " in your ", _jsx(_components.code, {
        children: "extends"
      }), " array. For example, if you have a Next.js app at ", _jsx(_components.code, {
        children: "./apps/web"
      }), " with ", _jsx(_components.code, {
        children: "\"name\": \"web\""
      }), " in its ", _jsx(_components.code, {
        children: "package.json"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".next/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!.next/cache/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "其他 Next.js 应用可以继承此配置并共享相同的配置："
    }), "\n", _jsx(_components.p, {
      children: "¥Another Next.js app can extend from it to share the same configuration:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/docs/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"web\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // Additional customization specific to this package"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"NEXT_PUBLIC_DOCS_URL\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "warn",
      children: [_jsxs(_components.p, {
        children: ["当继承自多个配置时，根 (", _jsx(_components.code, {
          children: "\"//\""
        }), ") 必须始终在 ", _jsx(_components.code, {
          children: "extends"
        }), " 数组中列在第一位。"]
      }), _jsxs(_components.p, {
        children: ["¥When extending from multiple configurations, the root (", _jsx(_components.code, {
          children: "\"//\""
        }), ") must always be\nlisted ", _jsx(_components.strong, {
          children: "first"
        }), " in the ", _jsx(_components.code, {
          children: "extends"
        }), " array."]
      })]
    }), "\n", _jsx(_components.h4, {
      id: "继承顺序-inheritance-order",
      children: "继承顺序 "
    }), "\n", _jsx(_components.p, {
      children: "¥Inheritance order"
    }), "\n", _jsxs(_components.p, {
      children: ["当继承自多个配置时，任务定义会按照它们在 ", _jsx(_components.code, {
        children: "extends"
      }), " 数组中出现的顺序合并："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When extending from multiple configurations, task definitions are merged in the order they appear in the ", _jsx(_components.code, {
        children: "extends"
      }), " array:"]
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["根包的 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " (", _jsx(_components.code, {
            children: "\"//\""
          }), ") 首先应用。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Root ", _jsx(_components.code, {
            children: "turbo.json"
          }), " (", _jsx(_components.code, {
            children: "\"//\""
          }), ") is applied first"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "每个附加包配置按顺序应用。"
        }), "\n", _jsx(_components.p, {
          children: "¥Each additional package configuration is applied in order"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当前包的配置最后应用。"
        }), "\n", _jsx(_components.p, {
          children: "¥The current package's configuration is applied last"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["对于标量字段，后续配置会覆盖早期配置。对于数组字段，请参阅“追加而不是替换 ", _jsxs(_components.a, {
        href: "#extending-arrays-with-turbo_extends",
        children: ["使用 ", _jsx(_components.code, {
          children: "$TURBO_EXTENDS$"
        }), " 扩展数组"]
      }), "”。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Later configurations override earlier ones for scalar fields. For array fields, see ", _jsxs(_components.a, {
        href: "#extending-arrays-with-turbo_extends",
        children: ["Extending arrays with ", _jsx(_components.code, {
          children: "$TURBO_EXTENDS$"
        })]
      }), " to append instead of replace."]
    }), "\n", _jsx(_components.h4, {
      id: "共享配置的模式-patterns-for-sharing-configuration",
      children: "共享配置的模式 "
    }), "\n", _jsx(_components.p, {
      children: "¥Patterns for sharing configuration"
    }), "\n", _jsx(_components.p, {
      children: "从现有包继承：如果你已经有一个包含要共享的配置的包，则其他包可以直接继承该配置。当一个包作为类似包的 \"canonical\" 示例时（例如，其他 Next.js 应用可以继承的主 Next.js 应用），此方法非常有效。"
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.strong, {
        children: "Extend from an existing package"
      }), ": If you already have a package with the configuration you want to share, other packages can extend from it directly. This works well when one package serves as the \"canonical\" example for similar packages (e.g., your main Next.js app that other Next.js apps can extend from)."]
    }), "\n", _jsxs(_components.p, {
      children: ["创建专用配置包：对于较大的单体仓库，你可能需要创建专门用于共享配置的包。这使配置与应用代码分离，并明确表明其他包依赖于这些设置。这些包通常只包含 ", _jsx(_components.code, {
        children: "package.json"
      }), " 和 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.strong, {
        children: "Create a dedicated configuration package"
      }), ": For larger monorepos, you may want to create packages specifically for sharing configuration. This keeps configuration separate from application code and makes it clear that other packages depend on these settings. These packages typically only contain a ", _jsx(_components.code, {
        children: "package.json"
      }), " and ", _jsx(_components.code, {
        children: "turbo.json"
      }), "."]
    }), "\n", _jsxs(Tabs, {
      items: ["shared-config/package.json", "shared-config/turbo.json", "apps/web/turbo.json"],
      children: [_jsx(Tab, {
        value: "shared-config/package.json",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./packages/shared-config/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"name\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"shared-config\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"private\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " true"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "shared-config/turbo.json",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./packages/shared-config/turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"extends\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"//\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"dist/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"cache\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " false"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"persistent\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " true"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "apps/web/turbo.json",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"extends\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"//\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"shared-config\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"env\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"MY_API_URL\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h3, {
      id: "从继承中排除任务-excluding-tasks-from-inheritance",
      children: "从继承中排除任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Excluding tasks from inheritance"
    }), "\n", _jsxs(_components.p, {
      children: ["当继承自根或其他包时，你的包默认会继承它们的所有任务定义。你可以使用任务级别的 ", _jsx(_components.code, {
        children: "extends"
      }), " 字段来选择退出特定任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When extending from the root or other packages, your package inherits all their task definitions by default. You can use the task-level ", _jsx(_components.code, {
        children: "extends"
      }), " field to opt out of specific tasks."]
    }), "\n", _jsx(_components.h4, {
      id: "完全排除任务-excluding-a-task-entirely",
      children: "完全排除任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Excluding a task entirely"
    }), "\n", _jsxs(_components.p, {
      children: ["要从包中完全排除继承的任务，请设置 ", _jsx(_components.code, {
        children: "extends: false"
      }), " 而不进行任何其他配置："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To completely exclude an inherited task from your package, set ", _jsx(_components.code, {
        children: "extends: false"
      }), " with no other configuration:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {}"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/ui/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " // This package does not have a lint task"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["运行 ", _jsx(_components.code, {
        children: "turbo run lint"
      }), " 时，对于 ", _jsx(_components.code, {
        children: "lint"
      }), " 任务，将完全跳过 ", _jsx(_components.code, {
        children: "ui"
      }), " 包。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When you run ", _jsx(_components.code, {
        children: "turbo run lint"
      }), ", the ", _jsx(_components.code, {
        children: "ui"
      }), " package will be skipped entirely for the ", _jsx(_components.code, {
        children: "lint"
      }), " task."]
    }), "\n", _jsx(_components.h4, {
      id: "创建新的任务定义-creating-a-fresh-task-definition",
      children: "创建新的任务定义 "
    }), "\n", _jsx(_components.p, {
      children: "¥Creating a fresh task definition"
    }), "\n", _jsxs(_components.p, {
      children: ["要创建不从 extends 链继承任何配置的新任务定义，请将 ", _jsx(_components.code, {
        children: "extends: false"
      }), " 与其他任务配置一起使用："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To create a new task definition that doesn't inherit any configuration from the extends chain, use ", _jsx(_components.code, {
        children: "extends: false"
      }), " along with other task configuration:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/special-app/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " // Don't inherit from root"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"out/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"SPECIAL_VAR\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "当你需要完全不同的任务配置，且这些配置不应与继承的值合并时，此功能非常有用。"
    }), "\n", _jsx(_components.p, {
      children: "¥This is useful when you need completely different task configuration that shouldn't merge with inherited values."
    }), "\n", _jsx(_components.h4, {
      id: "排除项会沿着链传播-exclusions-propagate-through-the-chain",
      children: "排除项会沿着链传播 "
    }), "\n", _jsx(_components.p, {
      children: "¥Exclusions propagate through the chain"
    }), "\n", _jsx(_components.p, {
      children: "当一个包排除某个任务时，该排除会传播到继承自它的包："
    }), "\n", _jsx(_components.p, {
      children: "¥When a package excludes a task, that exclusion propagates to packages that extend from it:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/base-config/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " // Exclude lint from this config"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"base-config\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "    // web does not inherit lint from root because base-config excluded it"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["任务级别的 ", _jsx(_components.code, {
          children: "extends"
        }), " 仅在包配置中可用。在根目录 ", _jsx(_components.code, {
          children: "turbo.json"
        }), " 中的任务上使用 ", _jsx(_components.code, {
          children: "extends"
        }), " 将导致验证错误。"]
      }), _jsxs(_components.p, {
        children: ["¥Task-level ", _jsx(_components.code, {
          children: "extends"
        }), " is only available in Package Configurations. Using\n", _jsx(_components.code, {
          children: "extends"
        }), " on a task in the root ", _jsx(_components.code, {
          children: "turbo.json"
        }), " will result in a validation\nerror."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "示例-examples",
      children: "示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Examples"
    }), "\n", _jsx(_components.h3, {
      id: "在一个应用中使用不同的框架工作区-different-frameworks-in-one-workspace",
      children: "在一个应用中使用不同的框架工作区 "
    }), "\n", _jsx(_components.p, {
      children: "¥Different frameworks in one Workspace"
    }), "\n", _jsxs(_components.p, {
      children: ["假设你的 monorepo 包含多个 ", _jsx(_components.a, {
        href: "https://next.nodejs.cn",
        children: "Next.js"
      }), " 应用和一个 ", _jsx(_components.a, {
        href: "https://kit.svelte.dev",
        children: "SvelteKit"
      }), " 应用。这两个框架都在各自的 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中使用 ", _jsx(_components.code, {
        children: "build"
      }), " 脚本创建构建输出。你可以像这样配置 Turborepo，使其在根目录下使用单个 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 任务来运行这些任务："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Let's say your monorepo has multiple ", _jsx(_components.a, {
        href: "https://next.nodejs.cn",
        children: "Next.js"
      }), " apps, and one ", _jsx(_components.a, {
        href: "https://kit.svelte.dev",
        children: "SvelteKit"
      }), "\napp. Both frameworks create their build output with a ", _jsx(_components.code, {
        children: "build"
      }), " script in their\nrespective ", _jsx(_components.code, {
        children: "package.json"
      }), ". You ", _jsx(_components.em, {
        children: "could"
      }), " configure Turborepo to run these tasks\nwith a single ", _jsx(_components.code, {
        children: "turbo.json"
      }), " at the root like this:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".next/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!.next/cache/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \".svelte-kit/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["请注意，即使 Next.js 应用不会生成 ", _jsx(_components.code, {
        children: ".svelte-kit"
      }), " 目录，", _jsx(_components.code, {
        children: ".next/**"
      }), " 和 ", _jsx(_components.code, {
        children: ".svelte-kit/**"
      }), " 都需要指定为 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: _jsx(_components.code, {
          children: "outputs"
        })
      }), "，反之亦然。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Notice that both ", _jsx(_components.code, {
        children: ".next/**"
      }), " and ", _jsx(_components.code, {
        children: ".svelte-kit/**"
      }), " need to be specified as\n", _jsx(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: _jsx(_components.code, {
          children: "outputs"
        })
      }), ", even though Next.js apps do not generate a ", _jsx(_components.code, {
        children: ".svelte-kit"
      }), " directory, and\nvice versa."]
    }), "\n", _jsxs(_components.p, {
      children: ["使用包配置，你可以在 ", _jsx(_components.code, {
        children: "apps/my-svelte-kit-app/turbo.json"
      }), " 中的 SvelteKit 包中添加自定义配置："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥With Package Configurations, you can instead add custom\nconfiguration in the SvelteKit package in ", _jsx(_components.code, {
        children: "apps/my-svelte-kit-app/turbo.json"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/my-svelte-kit-app/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".svelte-kit/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["并从根配置中移除 SvelteKit 特定的 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: _jsx(_components.code, {
          children: "outputs"
        })
      }), "："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥and remove the SvelteKit-specific ", _jsx(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: _jsx(_components.code, {
          children: "outputs"
        })
      }), " from the root configuration:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  \"tasks\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    \"build\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-      \"outputs\": [\".next/**\", \"!.next/cache/**\", \".svelte-kit/**\"]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+      \"outputs\": [\".next/**\", \"!.next/cache/**\"]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "这不仅使每个配置更易于阅读，还使配置更接近其使用位置。"
    }), "\n", _jsx(_components.p, {
      children: "¥This not only makes each configuration easier to read, it puts the configuration\ncloser to where it is used."
    }), "\n", _jsx(_components.h3, {
      id: "专门的任务-specialized-tasks",
      children: "专门的任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Specialized tasks"
    }), "\n", _jsxs(_components.p, {
      children: ["再举一个例子，假设一个软件包 ", _jsx(_components.code, {
        children: "dependsOn"
      }), " 中的 ", _jsx(_components.code, {
        children: "build"
      }), " 任务调用了一个 ", _jsx(_components.code, {
        children: "compile"
      }), " 任务。你可以将其声明为 ", _jsx(_components.code, {
        children: "dependsOn: [\"compile\"]"
      }), "。这意味着你的根 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 必须有一个空的 ", _jsx(_components.code, {
        children: "compile"
      }), " 任务条目："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In another example, say that the ", _jsx(_components.code, {
        children: "build"
      }), " task in one package ", _jsx(_components.code, {
        children: "dependsOn"
      }), " a\n", _jsx(_components.code, {
        children: "compile"
      }), " task. You could universally declare it as ", _jsx(_components.code, {
        children: "dependsOn: [\"compile\"]"
      }), ".\nThis means that your root ", _jsx(_components.code, {
        children: "turbo.json"
      }), " has to have an empty ", _jsx(_components.code, {
        children: "compile"
      }), " task\nentry:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"compile\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"compile\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {}"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["使用包配置，你可以将该 ", _jsx(_components.code, {
        children: "compile"
      }), " 任务移动到 ", _jsx(_components.code, {
        children: "apps/my-custom-app/turbo.json"
      }), "，"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥With Package Configurations, you can move that ", _jsx(_components.code, {
        children: "compile"
      }), " task into the\n", _jsx(_components.code, {
        children: "apps/my-custom-app/turbo.json"
      }), ","]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/my-app/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"compile\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"compile\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {}"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "并将其从根目录中移除："
    }), "\n", _jsx(_components.p, {
      children: "¥and remove it from the root:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  \"tasks\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+    \"build\": {}"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-    \"build\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-      \"dependsOn\": [\"compile\"]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-    },"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-    \"compile\": {}"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["现在，", _jsx(_components.code, {
        children: "my-app"
      }), " 的所有者可以完全拥有其 ", _jsx(_components.code, {
        children: "build"
      }), " 任务的所有权，但可以继续继承根目录中定义的任何其他任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Now, the owners of ", _jsx(_components.code, {
        children: "my-app"
      }), ", can have full ownership over their ", _jsx(_components.code, {
        children: "build"
      }), " task,\nbut continue to inherit any other tasks defined at the root."]
    }), "\n", _jsx(_components.h2, {
      id: "与特定于软件包的任务的比较-comparison-to-package-specific-tasks",
      children: "与特定于软件包的任务的比较 "
    }), "\n", _jsx(_components.p, {
      children: "¥Comparison to package-specific tasks"
    }), "\n", _jsxs(_components.p, {
      children: ["根包 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中的 ", _jsxs(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#depending-on-a-specific-task-in-a-specific-package",
        children: [_jsx(_components.code, {
          children: "package#task"
        }), " 语法"]
      }), " 会完全覆盖所有任务配置 - 不会继承任何配置。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsxs(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#depending-on-a-specific-task-in-a-specific-package",
        children: [_jsx(_components.code, {
          children: "package#task"
        }), " syntax"]
      }), " in the root ", _jsx(_components.code, {
        children: "turbo.json"
      }), " ", _jsx(_components.strong, {
        children: "completely overwrites"
      }), " all task configuration—nothing is inherited."]
    }), "\n", _jsx(_components.p, {
      children: "对于包配置，标量字段会被继承，只有你指定的字段会被覆盖。这意味着当你只需要更改一两个属性时，可以减少重复代码。"
    }), "\n", _jsx(_components.p, {
      children: "¥With Package Configurations, scalar fields are inherited and only the fields you specify are overridden. This means less duplication when you only need to change one or two properties."
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsx(_components.p, {
        children: "虽然没有计划移除特定于包的任务配置，但我们预计在大多数情况下可以使用包配置。"
      }), _jsx(_components.p, {
        children: "¥Although there are no plans to remove package-specific task configurations, we\nexpect that Package Configurations can be used for most use cases instead."
      })]
    }), "\n", _jsxs(_components.h2, {
      id: "experimental-边界标签-boundaries-tags-experimentalbadgeexperimentalexperimentalbadge",
      children: [_jsx(ExperimentalBadge, {
        children: "Experimental"
      }), " 边界标签 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Boundaries Tags ", _jsx(ExperimentalBadge, {
        children: "Experimental"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["软件包配置也用于声明边界标签。为此，请在你的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中添加一个 ", _jsx(_components.code, {
        children: "tags"
      }), " 字段："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Package Configurations are also used to declare Tags for Boundaries. To do so, add a ", _jsx(_components.code, {
        children: "tags"
      }), " field to your ", _jsx(_components.code, {
        children: "turbo.json"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/my-app/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+ \"tags\": [\"my-tag\"],"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  \"extends\": [\"//\"],"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  \"tasks\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    \"build\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      \"dependsOn\": [\"compile\"]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    },"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    \"compile\": {}"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["从这里，你可以定义标签可以包含哪些依赖或被依赖的规则。查看 ", _jsx(_components.a, {
        href: "/docs/reference/boundaries#tags",
        children: "边界文档"
      }), " 了解更多详细信息。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥From there, you can define rules for which dependencies or dependents a tag can have. Check out the ", _jsx(_components.a, {
        href: "/docs/reference/boundaries#tags",
        children: "Boundaries documentation"
      }), " for more details."]
    }), "\n", _jsx(_components.h2, {
      id: "限制-limitations",
      children: "限制 "
    }), "\n", _jsx(_components.p, {
      children: "¥Limitations"
    }), "\n", _jsxs(_components.p, {
      children: ["虽然总体思路与根 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 相同，但软件包配置附带一组防护措施，可以防止软件包造成潜在的混乱情况。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Although the general idea is the same as the root ", _jsx(_components.code, {
        children: "turbo.json"
      }), ", Package\nConfigurations come with a set of guardrails that can prevent packages from creating\npotentially confusing situations."]
    }), "\n", _jsxs(_components.h3, {
      id: "软件包配置不能使用-workspacetask-语法-作为任务条目-package-configurations-cannot-use-the-workspacetask-syntaxdocscrafting-your-repositoryrunning-tasks-as-task-entries",
      children: ["软件包配置不能使用 ", _jsxs(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks",
        children: [_jsx(_components.code, {
          children: "workspace#task"
        }), " 语法"]
      }), " 作为任务条目 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Package Configurations cannot use ", _jsxs(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks",
        children: ["the ", _jsx(_components.code, {
          children: "workspace#task"
        }), " syntax"]
      }), " as task entries"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "package"
      }), " 是根据配置的位置推断出来的，并且无法更改其他包的配置。例如，在 ", _jsx(_components.code, {
        children: "my-nextjs-app"
      }), " 的包配置中："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "package"
      }), " is inferred based on the location of the configuration, and it is\nnot possible to change configuration for another package. For example, in a\nPackage Configuration for ", _jsx(_components.code, {
        children: "my-nextjs-app"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/my-nextjs-app/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"my-nextjs-app#build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // This is not allowed. Even though it's"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // referencing the correct package, \"my-nextjs-app\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // is inferred, and we don't need to specify it again."
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // This syntax also has different behavior, so we do not want to allow it."
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // (see \"Comparison to package-specific tasks\" section)"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"my-sveltekit-app#build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // Changing configuration for the \"my-sveltekit-app\" package"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // from Package Configuration in \"my-nextjs-app\" is not allowed."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // Just use the task name!"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["请注意，", _jsx(_components.code, {
        children: "build"
      }), " 任务仍然可以依赖于特定于包的任务："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Note that the ", _jsx(_components.code, {
        children: "build"
      }), " task can still depend on a package-specific task:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/my-nextjs-app/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"some-pkg#compile\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "软件包配置只能覆盖-tasks-键中的值-package-configurations-can-only-override-values-in-the-tasks-key",
      children: ["软件包配置只能覆盖 ", _jsx(_components.code, {
        children: "tasks"
      }), " 键中的值 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Package Configurations can only override values in the ", _jsx(_components.code, {
        children: "tasks"
      }), " key"]
    }), "\n", _jsxs(_components.p, {
      children: ["无法在包配置中像 ", _jsx(_components.code, {
        children: "globalEnv"
      }), " 或 ", _jsx(_components.code, {
        children: "globalDependencies"
      }), " 那样覆盖 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#global-options",
        children: "全局配置"
      }), "。需要在包配置中更改的配置并非真正全局的，应该进行不同的配置。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥It is not possible to override ", _jsx(_components.a, {
        href: "/docs/reference/configuration#global-options",
        children: "global configuration"
      }), " like ", _jsx(_components.code, {
        children: "globalEnv"
      }), " or ", _jsx(_components.code, {
        children: "globalDependencies"
      }), " in a Package Configuration. Configuration that would need to be altered in a Package Configuration is not truly global and should be configured differently."]
    }), "\n", _jsxs(_components.h3, {
      id: "root-turbojson-无法使用-extends-键-root-turbojson-cannot-use-the-extends-key",
      children: ["Root turbo.json 无法使用 ", _jsx(_components.code, {
        children: "extends"
      }), " 键 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Root turbo.json cannot use the ", _jsx(_components.code, {
        children: "extends"
      }), " key"]
    }), "\n", _jsxs(_components.p, {
      children: ["为避免在包上创建循环依赖，根 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 不能从任何包扩展。", _jsx(_components.code, {
        children: "extends"
      }), " 键将被忽略。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To avoid creating circular dependencies on packages, the root ", _jsx(_components.code, {
        children: "turbo.json"
      }), "\ncannot extend from anything. The ", _jsx(_components.code, {
        children: "extends"
      }), " key will be ignored."]
    }), "\n", _jsx(_components.h2, {
      id: "故障排除-troubleshooting",
      children: "故障排除 "
    }), "\n", _jsx(_components.p, {
      children: "¥Troubleshooting"
    }), "\n", _jsxs(_components.p, {
      children: ["在大型单体仓库中，有时可能很难理解 Turborepo 如何解释你的配置。为了提供帮助，我们在 ", _jsx(_components.a, {
        href: "/docs/reference/run#--dry----dry-run",
        children: "试运行"
      }), " 输出中添加了 ", _jsx(_components.code, {
        children: "resolvedTaskDefinition"
      }), "。例如，如果你运行 ", _jsx(_components.code, {
        children: "turbo run build --dry-run"
      }), "，输出将包含在运行 ", _jsx(_components.code, {
        children: "build"
      }), " 任务之前考虑的所有 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 配置的组合。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In large monorepos, it can sometimes be difficult to understand how Turborepo is\ninterpreting your configuration. To help, we've added a ", _jsx(_components.code, {
        children: "resolvedTaskDefinition"
      }), "\nto the ", _jsx(_components.a, {
        href: "/docs/reference/run#--dry----dry-run",
        children: "Dry Run"
      }), " output. If you run ", _jsx(_components.code, {
        children: "turbo run build --dry-run"
      }), ", for example, the\noutput will include the combination of all ", _jsx(_components.code, {
        children: "turbo.json"
      }), " configurations that were\nconsidered before running the ", _jsx(_components.code, {
        children: "build"
      }), " task."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
